import { Box } from './styles';

type InfoBoxProps = {
    variant?: 'warning' | 'info';
};
export const InfoBox: React.FCC<InfoBoxProps> = ({
    children,
    variant = 'info',
}) => {
    return <Box variant={variant}>{children}</Box>;
};
